import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';


interface Props {
    value: WorkScheduleType | null;
    setValue: React.Dispatch<React.SetStateAction<WorkScheduleType | null>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    disabled?: boolean;
}

export default function WorkScheduleTypeDropdown({ value, setValue, zIndex, labelStyle, viewStyle, disabled }: Props) {
    const items = useMemo(() => [
        { label: 'daily', value: '5/2' },
        { label: '12/36', value: '12/36' },
    ].map(item => {
        return { label: translate(item.label), value: item.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('workScheduleType')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            disabled={disabled}
        />
    );
}
